import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { type BrandData } from '../data/products';
import { fetchBrands } from '../lib/api';

interface BrandsState {
  brands: BrandData[];
  loading: boolean;
  error: string | null;
}

const BrandsContext = createContext<BrandsState>({
  brands: [],
  loading: true,
  error: null,
});

export function BrandsProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<BrandsState>({ brands: [], loading: true, error: null });

  useEffect(() => {
    fetchBrands()
      .then(data => setState({ brands: data, loading: false, error: null }))
      .catch(err => setState({ brands: [], loading: false, error: String(err) }));
  }, []);

  return <BrandsContext.Provider value={state}>{children}</BrandsContext.Provider>;
}

export function useBrands(): BrandsState {
  return useContext(BrandsContext);
}
